require('./bootstrap');
import Vue from "vue";

import VueLazyload from 'vue-lazyload'
import VueSweetalert2 from "vue-sweetalert2";
Vue.use(VueLazyload)
Vue.use(VueSweetalert2)
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('product-index', require('./components/products/index.vue').default);
Vue.component('product-add_edit', require('./components/products/add_edit.vue').default);


var app = new Vue({
    el: '#app',
});